/*! Ardor Rigid Sign Designer Kit v1 (Oct 20, 2026) - Ardor Printing, ardorprinting.com
 * Copy of assets/ardor-designer-kit-v2.js (the banner designer kit with the Oct 20 upload fix) for the Rigid Sign
 * Designer: Templates (business signs), Add heading / subheading / body text, Text suggestions, Quick text, Background,
 * QR code, logo spot, sample-text warning, and the upload fix (an upload on a side with a template or background asks
 * "Add as a logo" or "Use as full artwork"; the customer's own layers stay when a template is re-arranged).
 * Talks to the designer only through window.ArdorRigidLayers.kit and window.ArdorRigidAPI (via kit.api()).
 * Heavy parts load on first use from window.ArdorKitAssets: bg (ArdorBG), data (ArdorTPLData from
 * assets/ardor-rigid-tpl-data.js), tpl (ArdorTPL), qr (ArdorQR).
 * Faces: front, back. Templates are laid out in the layout area = the safe area minus keep-clear boxes around holes,
 * grommets and standoffs (API.guides(face)), clamped to 6:1 / 1:2.4; the layout (xwide / wide / square / tall) follows
 * that area. Every face that holds a template carries a fit marker on its background layer (ablBg.fit / ablBg.tpl); any
 * change of size, holes or corners re-arranges that face, on screen or not (fitAll).
 * Template details are kept in localStorage key ardorKitInfoRS: { business, tagline, phone, web }.
 */
(function () {
  'use strict';
  if (window.ArdorRigidKit) return;

  var K = null, API = null, fabric = null, fc = null, booted = false, uiReady = false;
  var ASSETS = window.ArdorKitAssets || {};
  var loaded = {}, loading = {};
  var st = { info: { business: '', tagline: '', phone: '', web: '' }, tpl: null, tplFace: null, tplVar: '', tplDirty: false, suggCat: '', tplCat: '', bgCat: 'Solid', thumbs: {}, thumbKey: '', qrEdit: null, rebuilding: false };
  var FONT_PRE = ['Anton', 'Jost', 'Bebas Neue', 'Unbounded', 'Rubik Mono One', 'Pacifico', 'Monoton', 'Satisfy', 'Bree Serif', 'Bangers', 'Quicksand', 'Permanent Marker', 'Black Ops One', 'Righteous', 'Lobster'];

  // ---------- helpers ----------
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function phone() { try { return window.matchMedia('(max-width: 900px)').matches; } catch (e) { return window.innerWidth <= 900; } }
  function toast(m, ms, act) { try { K.toast(m, ms || 4000, act); } catch (e) {} }
  function track(k) { try { (window.dataLayer = window.dataLayer || []).push({ event: 'ardor_kit_' + k }); } catch (e) {} }
  function lsGet(k) { try { return JSON.parse(window.localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function failed(e) { try { console.warn('[ardor kit]', e); } catch (x) {} toast('That tool could not load. Please refresh the page and try again.', 6000); }

  // ---------- rigid signs (Oct 20 2026): layout area, details, fit markers ----------
  var INFO_KEY = 'ardorKitInfoRS', FACES = ['front', 'back'], XW_MAX = 6, TALL_MIN = 1 / 2.4;
  function r2(v) { return Math.round(v * 100) / 100; }
  function guidesFor(face) { try { return (API && API.guides) ? (API.guides(face || curFace()) || null) : null; } catch (e) { return null; } }
  // keep-clear boxes [x, y, w, h] around holes, grommets and standoff caps of a face (from the designer, else from its holes)
  function keepFor(face) {
    var g = guidesFor(face), out = [];
    if (!g) return out;
    if (g.keep && g.keep.length) { g.keep.forEach(function (k) { k = (k && (k.r || k.rect)) || k; if (k && k.length === 4) out.push(k); }); return out; }
    (g.holes || []).forEach(function (h) { if (!h || h.length < 2) return; var r = (h[2] || 0.25) / 2 + 0.2; out.push([h[0] - r, h[1] - r, 2 * r, 2 * r]); });
    return out;
  }
  // the area templates are laid out in: the safe area pulled in off the cheapest edge for every keep box (so no template
  // text sits under a hole, grommet or standoff), then clamped to 6:1 / 1:2.4 and centred (bands still reach the edges)
  function tplArea(z, face) {
    var safe = z.safe, W = z.Wi, H = z.Hi, mI = Math.min(0.25, 0.03 * Math.min(safe.w, safe.h)), s = { x: safe.x + mI, y: safe.y + mI, w: safe.w - 2 * mI, h: safe.h - 2 * mI }; // RS-CORE round 5: template text keeps clear of the safe line
    keepFor(face || curFace()).forEach(function (k) {
      var x0 = k[0], y0 = k[1], x1 = k[0] + k[2], y1 = k[1] + k[3], cx = (x0 + x1) / 2, cy = (y0 + y1) / 2, best = null, c = [];
      if (x1 <= s.x || x0 >= s.x + s.w || y1 <= s.y || y0 >= s.y + s.h) return;
      if (cx <= W * 0.35) c.push(['l', (x1 - s.x) / s.w]);
      if (cx >= W * 0.65) c.push(['r', (s.x + s.w - x0) / s.w]);
      if (cy <= H * 0.35) c.push(['t', (y1 - s.y) / s.h]);
      if (cy >= H * 0.65) c.push(['b', (s.y + s.h - y0) / s.h]);
      c.forEach(function (o) { if (!best || o[1] < best[1]) best = o; });
      if (!best) return;
      if (best[0] === 'l') { s.w -= x1 - s.x; s.x = x1; }
      else if (best[0] === 'r') { s.w = x0 - s.x; }
      else if (best[0] === 't') { s.h -= y1 - s.y; s.y = y1; }
      else { s.h = y0 - s.y; }
    });
    if (!(s.w >= safe.w * 0.5 && s.h >= safe.h * 0.5)) s = { x: safe.x, y: safe.y, w: safe.w, h: safe.h };
    var r = s.w / s.h;
    if (r > XW_MAX) { var nw = s.h * XW_MAX; s.x += (s.w - nw) / 2; s.w = nw; }
    else if (r < TALL_MIN) { var nh = s.w / TALL_MIN; s.y += (s.h - nh) / 2; s.h = nh; }
    return { x: r2(s.x), y: r2(s.y), w: r2(s.w), h: r2(s.h) };
  }
  // what ArdorTPL substitutes; a 'qr-custom' template (Wi-Fi) never gets the website as its QR code
  function tinfo(it) {
    var i = st.info || {}, web = i.web || '';
    if (it && it.tags && it.tags.indexOf('qr-custom') >= 0) web = '';
    return { business: i.business || '', tagline: i.tagline || '', phone: i.phone || '', web: web };
  }
  function tplBuild(it, z, face) {
    var a = tplArea(z, face);
    return window.ArdorTPL.build(fabric, it, z.Wi, z.Hi, a, { info: tinfo(it), qrPath: qrPathFn, variant: window.ArdorTPL.variant(a.w, a.h) });
  }
  // what a template was laid out for (page + layout area), kept on the face's background layer (saved with undo / redo)
  function areaKey(W, H, a) { return r2(W) + 'x' + r2(H) + '|' + [a.x, a.y, a.w, a.h].map(r2).join(','); }
  function fitSpec(spec, id, key) { var o = {}, k; spec = spec || { t: 'solid', c: '#FFFFFF' }; for (k in spec) { if (Object.prototype.hasOwnProperty.call(spec, k)) o[k] = spec[k]; } o.fit = key; o.tpl = id; return o; }
  function keepFit(spec, prev) { if (!prev || !prev.fit || !spec) return spec; return fitSpec(spec, prev.tpl, prev.fit); }
  function faceMark(list) { for (var i = 0; i < (list || []).length; i++) { var o = list[i]; if (o && o.ablKind === 'bg' && o.ablBg && o.ablBg.tpl && o.ablBg.fit) return { id: o.ablBg.tpl, fit: o.ablBg.fit }; } return null; }
  function faceList(f) { try { return f === curFace() ? (canvas() ? fc.getObjects() : []) : (K.objectsFor(f) || []); } catch (e) { return []; } }
  function faceTplItem(f) { var m = faceMark(faceList(f)); return m && window.ArdorTPL ? window.ArdorTPL.get(m.id) : null; }
  function fontsOk(list) { try { return list.every(function (n) { return document.fonts.check('20px "' + n + '"'); }); } catch (e) { return true; } }

  function load(name) {
    var glob = { bg: 'ArdorBG', data: 'ArdorTPLData', tpl: 'ArdorTPL', qr: 'ArdorQR' }[name];
    if (glob && window[glob]) return Promise.resolve(window[glob]);
    if (loading[name]) return loading[name];
    loading[name] = new Promise(function (res, rej) {
      var src = ASSETS[name];
      if (!src) { rej(new Error('no asset url for ' + name)); return; }
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = function () { loaded[name] = true; if (window[glob]) res(window[glob]); else rej(new Error(name)); };
      s.onerror = function () { loading[name] = null; rej(new Error('load ' + name)); };
      document.head.appendChild(s);
    });
    return loading[name];
  }
  function loadTpl() { return load('data').then(function () { return load('tpl'); }); }

  function cfgSize() { var b = K.banner(); return { b: b, Wi: b.Wi, Hi: b.Hi, safe: K.safeArea(b.c, b.Wi, b.Hi) }; }
  function canvas() { fc = K.canvas(); return fc; }
  function curFace() { return K.face(); }
  function objs() { return canvas() ? fc.getObjects() : []; }
  function bgObj() { var o = objs().filter(function (x) { return x.ablKind === 'bg'; }); return o[0] || null; }
  function faceArt(f) { try { return API.getArt(f || curFace()); } catch (e) { return null; } }
  function fontsReady(list) {
    return K.loadFonts().then(function () { return Promise.all(list.map(function (f) { return K.fontReady(f); })); });
  }

  // ---------- custom Fabric classes ----------
  function registerClasses() {
    if (fabric.ArdorBg) return;
    fabric.ArdorBg = fabric.util.createClass(fabric.Object, {
      type: 'ardorBg',
      initialize: function (o) {
        o = o || {};
        this.callSuper('initialize', o);
        this.set({ originX: 'left', originY: 'top', strokeWidth: 0, stroke: null, selectable: false, evented: false, hasControls: false, hasBorders: false, objectCaching: false, ablKind: 'bg' });
        this.ablBg = o.ablBg || { t: 'solid', c: '#FFFFFF' };
      },
      _render: function (ctx) {
        var w = this.width, h = this.height;
        if (window.ArdorBG) { try { window.ArdorBG.draw(ctx, -w / 2, -h / 2, w, h, this.ablBg); return; } catch (e) {} }
        ctx.fillStyle = (this.ablBg && this.ablBg.c) || '#FFFFFF'; ctx.fillRect(-w / 2, -h / 2, w, h);
      }
    });
    fabric.ArdorBg.fromObject = function (o, cb) { var x = new fabric.ArdorBg(o); if (cb) cb(x); return x; };
  }

  // ---------- boot ----------
  function boot() {
    if (booted) return;
    var L = window.ArdorRigidLayers;
    if (!L || !L.kit) return;
    K = L.kit; API = K.api(); booted = true;
    if (K.ui() && K.ui().drawer) buildUi();
    else document.addEventListener('ardor:layers-kit-ui', function () { buildUi(); });
    setInterval(watchSize, 450);
    // re-arrange right after the designer redraws (size, material, sides, holes or corners changed)
    document.addEventListener('ardor:rigid-view', function () { clearTimeout(st.fitT); st.fitT = setTimeout(function () { try { fitAll(); } catch (e) {} }, 30); });
    guardUploads();
    // load Fabric + the background module early but idle, so undo / restore of backgrounds always works
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2500); };
    idle(function () { withFabric().catch(function () {}); });
  }
  function withFabric() {
    return K.ready().then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      return load('bg');
    });
  }
  var hooked = false;
  function hookCanvas() {
    if (hooked || !fc) return; hooked = true;
    var sb = fc.sendBackwards, stb = fc.sendToBack;
    fc.sendBackwards = function (o) { var r = sb.apply(fc, arguments); bgBottom(); return r; };
    fc.sendToBack = function (o) { var r = stb.apply(fc, arguments); if (o && o.ablKind !== 'bg') bgBottom(); return r; };
    fc.on('object:added', function () { bgBottom(); if (!st.rebuilding) qtRefreshSoon(); });
    fc.on('object:removed', function () { if (!st.rebuilding) qtRefreshSoon(); });
    fc.on('object:modified', function (e) { if (!st.rebuilding && e && e.target && e.target.ablTpl) st.tplDirty = true; });
    fc.on('text:changed', function (e) { if (e && e.target && e.target.ablTpl) st.tplDirty = true; qtRefreshSoon(true); });
    fc.on('selection:created', selSync); fc.on('selection:updated', selSync); fc.on('selection:cleared', selSync);
    fc.on('after:render', drawGuides);
  }
  // with a full background layer the designer's own guides (safe line, hems, grommets) sit under it: draw them on top
  // rigid: hidden zones, the rounded-corner cut, the dashed safe line and the holes / grommets / standoffs of the face
  // from API.guides(face), drawn on top when a template or background layer covers the sign
  function rrPath(ctx, x, y, w, h, r) { ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }
  function drawGuides() {
    if (!fc || !bgObj()) return;
    var z; try { z = cfgSize(); } catch (e) { return; }
    var g = guidesFor(curFace());
    var Wi = z.Wi, Hi = z.Hi, v = fc.viewportTransform, rs = fc.getRetinaScaling ? fc.getRetinaScaling() : 1, ctx = fc.getContext();
    if (!ctx || !v || !(Wi > 0) || !(Hi > 0)) return;
    var lw = Math.max(Wi, Hi) / 600, s = (g && g.safe) || z.safe, cr = g && g.corner > 0 ? Math.min(g.corner, Wi / 2, Hi / 2) : 0;
    ctx.save();
    ctx.setTransform(v[0] * rs, 0, 0, v[3] * rs, v[4] * rs, v[5] * rs);
    ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); ctx.clip();
    if (cr) { ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); rrPath(ctx, 0, 0, Wi, Hi, cr); ctx.fillStyle = 'rgba(12,13,13,0.45)'; ctx.fill('evenodd'); }
    ctx.fillStyle = 'rgba(12,13,13,0.30)';
    ((g && g.hidden) || []).forEach(function (r) { r = (r && r.rect) || r; if (r && r.length === 4) ctx.fillRect(r[0], r[1], r[2], r[3]); });
    if (s && s.w > 0 && s.h > 0) {
      ctx.setLineDash([lw * 6, lw * 4]); ctx.lineWidth = lw * 1.5; ctx.strokeStyle = 'rgba(255,255,255,0.75)';
      ctx.strokeRect(s.x, s.y, s.w, s.h);
      ctx.lineDashOffset = lw * 5; ctx.strokeStyle = 'rgba(189,37,44,0.95)';
      ctx.strokeRect(s.x, s.y, s.w, s.h);
      ctx.setLineDash([]);
    }
    ((g && g.holes) || []).forEach(function (h) {
      if (!h || h.length < 2) return;
      var r = Math.max(0.08, (h[2] || 0.25) / 2), kind = h[3] || 'hole';
      ctx.beginPath(); ctx.arc(h[0], h[1], kind === 'standoff' ? r : r + (kind === 'grommet' ? 0.16 : 0.08), 0, Math.PI * 2);
      ctx.fillStyle = kind === 'grommet' ? '#B8962E' : (kind === 'standoff' ? '#C9CDD2' : '#B9BCBF'); ctx.fill();
      if (kind === 'standoff') { ctx.lineWidth = lw * 1.2; ctx.strokeStyle = '#7D838A'; ctx.stroke(); ctx.beginPath(); ctx.arc(h[0], h[1], r * 0.55, 0, Math.PI * 2); ctx.fillStyle = '#E9ECEF'; ctx.fill(); }
      else { ctx.beginPath(); ctx.arc(h[0], h[1], kind === 'grommet' ? Math.max(0.08, r * 0.6) : r, 0, Math.PI * 2); ctx.fillStyle = '#FFFFFF'; ctx.fill(); }
    });
    ctx.restore();
  }
  function bgBottom() { var b = bgObj(); if (b && fc.getObjects().indexOf(b) > 0) { fc.moveTo(b, 0); fc.requestRenderAll(); } }

  // ---------- UI ----------
  var IC = {
    tpl: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>',
    bg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="m3 16 5-5 4 4 3-3 6 6"/><circle cx="16" cy="9" r="1.6"/></svg>',
    qr: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="20" height="20"><path d="M6 6l12 12M18 6 6 18"/></svg>'
  };
  var ui = {};
  function railBtn(name, icon, label) {
    var b = el('button', 'abx-tool abl-tool adk-tool', '<span class="abl-tool-ic" aria-hidden="true">' + icon + '</span><span>' + label + '</span>');
    b.type = 'button'; b.setAttribute('data-abl-tool', name); b.setAttribute('aria-expanded', 'false');
    return b;
  }
  function panel(name, title, body) {
    var p = el('div', 'abl-drawer__panel adk-panel', '<div class="abl-drawer__head"><h2>' + title + '</h2><button type="button" class="abl-x" data-adk-close aria-label="Close">' + IC.x + '</button></div><div class="abl-drawer__body adk-body">' + body + '</div>');
    p.setAttribute('data-abl-panel', name); p.hidden = true;
    $('[data-adk-close]', p).addEventListener('click', function () { K.closeDrawer(); });
    ui.drawer.appendChild(p);
    return p;
  }
  function buildUi() {
    if (uiReady) return;
    var u = K.ui(); if (!u || !u.drawer) return;
    uiReady = true; ui.drawer = u.drawer;
    var rail = document.querySelector('.abx-rail');
    var textBtn = rail && $('[data-abl-tool="text"]', rail), clipBtn = rail && $('[data-abl-tool="clipart"]', rail);
    ui.tTpl = railBtn('templates', IC.tpl, 'Templates');
    ui.tBg = railBtn('background', IC.bg, 'Background');
    ui.tQr = railBtn('qr', IC.qr, 'QR code');
    if (rail && textBtn) {
      rail.insertBefore(ui.tTpl, textBtn);
      var after = clipBtn ? clipBtn.nextSibling : textBtn.nextSibling;
      rail.insertBefore(ui.tBg, after); rail.insertBefore(ui.tQr, ui.tBg.nextSibling);
    } else {
      var host = (textBtn && textBtn.parentNode) || document.querySelector('.abl-minirail');
      if (host) { host.insertBefore(ui.tTpl, host.firstChild); host.appendChild(ui.tBg); host.appendChild(ui.tQr); }
    }
    // the print-template download button keeps working; its label now says what it is
    $$('.abx-rail .abx-tool').forEach(function (b) { var s = b.querySelector('span:last-child'); if (s && /^\s*Template\s*$/.test(s.textContent) && !b.classList.contains('adk-tool')) { s.textContent = 'Print template'; b.title = 'Download a print-ready template for this size (for your own designer)'; } });
    [ui.tTpl, ui.tBg, ui.tQr].forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-abl-tool');
        setTimeout(function () { if (n === 'templates') openTemplates(); if (n === 'background') openBackground(); if (n === 'qr') openQr(); }, 0);
      });
    });
    buildTextExtras();
    buildTemplatesPanel();
    buildBgPanel();
    buildQrPanel();
    buildPropsExtras();
    var saved = lsGet(INFO_KEY); if (saved) st.info = { business: saved.business || '', tagline: saved.tagline || '', phone: saved.phone || '', web: saved.web || '' };
    syncInfoFields();
    // the empty canvas card: offer templates too
    var card = document.querySelector('.abx-empty__card');
    if (card && !card.querySelector('.adk-empty-tpl')) {
      var a = el('button', 'adk-empty-tpl', IC.tpl + ' <span>Start from a <u>ready-made template</u></span>'); a.type = 'button';
      a.addEventListener('click', function () { ui.tTpl.click(); });
      card.appendChild(a);
    }
    if (/[#&?]kit=templates/.test(location.href)) setTimeout(function () { ui.tTpl.click(); }, 600);
    // ?tpl=<template id> (works with ?preset=w:8,h:4): open the designer with that template already on the sign
    var tm = /[#&?]tpl=([a-z0-9-]+)/i.exec(location.href);
    if (tm) setTimeout(function () { loadTpl().then(function () { var it = window.ArdorTPL.get(tm[1]); if (it && !designOnFace()) applyTemplate(it, { reason: 'link' }); }).catch(function () {}); }, /[?&]preset=/.test(location.search) ? 1800 : 700);
  }

  // ---------- Text: presets, suggestions, quick text ----------
  function buildTextExtras() {
    var tp = $('[data-abl-panel="text"]', ui.drawer); if (!tp) return;
    var body = $('.abl-drawer__body', tp);
    var fontsWrap = el('div', 'adk-tabpane', ''); fontsWrap.setAttribute('data-adk-pane', 'fonts');
    while (body.firstChild) fontsWrap.appendChild(body.firstChild);
    var top = el('div', 'adk-text-top',
      '<div class="adk-presets">' +
        '<button type="button" class="adk-preset adk-preset--h" data-adk-preset="h"><b>Add a heading</b></button>' +
        '<button type="button" class="adk-preset adk-preset--s" data-adk-preset="s"><b>Add a subheading</b></button>' +
        '<button type="button" class="adk-preset adk-preset--b" data-adk-preset="b"><b>Add body text</b></button>' +
      '</div>' +
      '<div class="adk-tabs" role="tablist"><button type="button" role="tab" data-adk-tab="sugg" aria-selected="true">Suggestions</button><button type="button" role="tab" data-adk-tab="fonts" aria-selected="false">Fonts</button><button type="button" role="tab" data-adk-tab="quick" aria-selected="false">Quick text</button></div>');
    body.appendChild(top);
    var sugg = el('div', 'adk-tabpane', '<div class="adk-chips" data-adk-sugg-cats></div><div class="adk-grid adk-grid--sugg" data-adk-sugg><p class="abl-help">Loading ideas...</p></div>');
    sugg.setAttribute('data-adk-pane', 'sugg');
    var quick = el('div', 'adk-tabpane', '<p class="abl-help">Every line of text on this side of your sign. Change the words here; the sign updates as you type.</p><div class="adk-quick" data-adk-quick></div>');
    quick.setAttribute('data-adk-pane', 'quick'); quick.hidden = true; fontsWrap.hidden = true;
    body.appendChild(sugg); body.appendChild(fontsWrap); body.appendChild(quick);
    ui.textBody = body; ui.sugg = $('[data-adk-sugg]', sugg); ui.suggCats = $('[data-adk-sugg-cats]', sugg); ui.quick = $('[data-adk-quick]', quick);
    $$('[data-adk-preset]', top).forEach(function (b) { b.addEventListener('click', function () { addPreset(b.getAttribute('data-adk-preset')); }); });
    $$('[data-adk-tab]', top).forEach(function (b) {
      b.addEventListener('click', function () { textTab(b.getAttribute('data-adk-tab')); });
    });
    var textRail = document.querySelector('[data-abl-tool="text"]');
    if (textRail) textRail.addEventListener('click', function () { setTimeout(function () { if (st.textTab === 'sugg' || !st.textTab) renderSuggestions(); if (st.textTab === 'quick') renderQuick(); }, 0); });
    st.textTab = 'sugg';
  }
  function textTab(name) {
    st.textTab = name;
    $$('[data-adk-tab]', ui.textBody).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-adk-tab') === name ? 'true' : 'false'); });
    $$('[data-adk-pane]', ui.textBody).forEach(function (p) { p.hidden = p.getAttribute('data-adk-pane') !== name; });
    if (name === 'sugg') renderSuggestions();
    if (name === 'quick') renderQuick();
  }
  function addPreset(kind) {
    var fam = kind === 'h' ? 'Anton' : 'Jost';
    K.ready().then(function () { fabric = K.fabric(); canvas(); registerClasses(); hookCanvas(); return fontsReady([fam]); }).then(function () {
      K.targetFace();
      var z = cfgSize(), s = z.safe, b = bgObj(), dark = false;
      try { dark = b && window.ArdorBG ? window.ArdorBG.isDark(b.ablBg) : false; } catch (e) {}
      var H = Math.min(s.h * 0.30, s.w * 0.16);
      var spec = {
        h: { t: 'Add a heading', fs: H, y: s.y + s.h * 0.28, w: s.w * 0.92 },
        s: { t: 'Add a subheading', fs: H * 0.46, y: s.y + s.h * 0.56, w: s.w * 0.86 },
        b: { t: 'Add a little bit of body text', fs: H * 0.26, y: s.y + s.h * 0.78, w: s.w * 0.8 }
      }[kind];
      var t = K.look(new fabric.IText(kind === 'h' ? spec.t.toUpperCase() : spec.t, { fontFamily: fam, fontSize: spec.fs, fill: dark ? '#FFFFFF' : '#16161b', textAlign: 'center', originX: 'center', originY: 'center', left: z.Wi / 2, top: spec.y, paintFirst: 'stroke', strokeLineJoin: 'round', strokeWidth: 0, stroke: null, ablKind: 'text', ablStroke: 0, ablRole: kind === 'h' ? 'headline' : (kind === 's' ? 'sub' : 'detail'), charSpacing: kind === 'h' ? 20 : 0 }));
      if (kind !== 'h' && fam === 'Jost') t.set({ fontWeight: kind === 's' ? '600' : '400' });
      var w = t.getScaledWidth(); if (w > spec.w) t.scale(t.scaleX * spec.w / w);
      // don't land exactly on top of another text
      var tries = 0;
      while (tries++ < 4 && fc.getObjects().some(function (o) { return o !== t && o.ablKind === 'text' && Math.abs(o.top - t.top) < spec.fs * 0.6 && Math.abs(o.left - t.left) < z.Wi * 0.3; })) t.set({ top: clamp(t.top + spec.fs * 1.1, s.y + spec.fs / 2, s.y + s.h - spec.fs / 2) });
      K.fitInside(t, s);
      K.place(t);
      track('text_' + kind);
    }).catch(failed);
  }

  function isDarkFace() { var b = bgObj(); try { if (b && window.ArdorBG) return window.ArdorBG.isDark(b.ablBg); } catch (e) {} return false; }
  function renderSuggestions() {
    if (!ui.sugg) return;
    Promise.all([K.ready(), loadTpl(), load('bg')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var T = window.ArdorTPL, cats = T.suggestionCategories ? T.suggestionCategories() : [];
      if (!ui.suggCats.children.length) {
        var all = el('button', 'adk-chip', 'All'); all.type = 'button'; all.setAttribute('data-c', ''); ui.suggCats.appendChild(all);
        cats.forEach(function (c) { var n = typeof c === 'string' ? c : (c.name || c.id); var id = typeof c === 'string' ? c : (c.id || c.name); var b = el('button', 'adk-chip', esc(n)); b.type = 'button'; b.setAttribute('data-c', id); ui.suggCats.appendChild(b); });
        ui.suggCats.addEventListener('click', function (e) { var b = e.target.closest('[data-c]'); if (!b) return; st.suggCat = b.getAttribute('data-c'); renderSuggestions(); });
      }
      $$('[data-c]', ui.suggCats).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === st.suggCat ? 'true' : 'false'); });
      var items = T.listSuggestions(st.suggCat), dark = isDarkFace();
      return fontsReady(FONT_PRE).then(function () {
        ui.sugg.textContent = '';
        items.forEach(function (it, i) {
          var b = el('button', 'adk-card adk-card--sugg' + (dark ? ' is-dark' : '')); b.type = 'button'; b.title = it.name; b.setAttribute('aria-label', 'Add ' + it.name);
          b.addEventListener('click', function () { addSuggestion(it); });
          ui.sugg.appendChild(b);
          setTimeout(function () { try { b.appendChild(suggThumb(it, dark)); } catch (e) {} }, i * 12);
        });
      });
    }).catch(failed);
  }
  function suggThumb(it, dark) {
    var key = 's|' + it.id + '|' + dark;
    if (st.thumbs[key]) { var im0 = new Image(); im0.src = st.thumbs[key]; im0.alt = ''; return im0; }
    var bw = 50, bh = 22, px = 6;
    var objsT = window.ArdorTPL.buildSuggestion(fabric, it, { x: 1, y: 1, w: bw - 2, h: bh - 2 }, { dark: dark, info: tinfo() });
    var cv = el('canvas'); var sc = new fabric.StaticCanvas(cv, { width: bw * px, height: bh * px, enableRetinaScaling: false, renderOnAddRemove: false });
    sc.setViewportTransform([px, 0, 0, px, 0, 0]);
    sc.backgroundColor = dark ? '#1d2230' : '#f4f2ec';
    objsT.forEach(function (o) { sc.add(o); });
    sc.renderAll();
    var url = sc.toDataURL({ format: 'png' });
    sc.dispose();
    st.thumbs[key] = url;
    var im = new Image(); im.src = url; im.alt = ''; return im;
  }
  function addSuggestion(it) {
    Promise.all([K.ready(), loadTpl()]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      return fontsReady(window.ArdorTPL.fonts(it));
    }).then(function () {
      K.targetFace();
      var z = cfgSize(), s = z.safe, others = fc.getObjects().filter(function (o) { return o.ablKind !== 'bg'; }).length;
      var bw = others ? s.w * 0.62 : s.w * 0.9, bh = others ? s.h * 0.5 : s.h * 0.8;
      if (s.w / s.h < 1) { bw = s.w * (others ? 0.8 : 0.92); bh = s.h * (others ? 0.38 : 0.6); }
      var box = { x: z.Wi / 2 - bw / 2, y: (s.y + s.h / 2) - bh / 2, w: bw, h: bh };
      var list = window.ArdorTPL.buildSuggestion(fabric, it, box, { dark: isDarkFace(), info: tinfo() });
      K.setQuiet(true);
      list.forEach(function (o) { K.look(o); o.ablTpl = null; fc.add(o); });
      K.setQuiet(false);
      if (list.length > 1) { var sel = new fabric.ActiveSelection(list, { canvas: fc }); K.look(sel); fc.setActiveObject(sel); }
      else if (list[0]) fc.setActiveObject(list[0]);
      K.changed(true); K.syncProps(); fc.requestRenderAll();
      if (phone()) K.closeDrawer();
      toast('Added. Drag to move it, or tap a line of text to change the words.', 4500);
      track('suggestion');
    }).catch(failed);
  }

  var qtT = 0;
  function qtRefreshSoon(skipFocused) { clearTimeout(qtT); qtT = setTimeout(function () { if (st.textTab === 'quick' && ui.quick && !ui.quick.closest('[hidden]')) renderQuick(skipFocused); }, 120); }
  function renderQuick(skipFocused) {
    if (!ui.quick) return;
    if (skipFocused && ui.quick.contains(document.activeElement)) return;
    var texts = objs().filter(function (o) { return o.ablKind === 'text' || o.type === 'i-text'; });
    ui.quick.textContent = '';
    if (!texts.length) { ui.quick.appendChild(el('p', 'abl-help', 'No text on this side yet. Add a heading, a suggestion or a template first.')); return; }
    texts.forEach(function (o, i) {
      var ta = el('textarea', 'abl-input abl-textarea adk-qt'); ta.rows = Math.min(3, String(o.text).split('\n').length); ta.value = o.text; ta.setAttribute('aria-label', 'Text line ' + (i + 1));
      ta.style.fontFamily = '\'' + o.fontFamily + '\', sans-serif';
      ta.addEventListener('focus', function () { try { fc.setActiveObject(o); fc.requestRenderAll(); K.syncProps(); } catch (e) {} });
      ta.addEventListener('input', function () { o.set('text', ta.value || ' '); if (o.ablStroke) o.set({ strokeWidth: o.fontSize * o.ablStroke * 0.012 }); o.setCoords(); fc.requestRenderAll(); if (o.ablTpl) st.tplDirty = true; try { API.renderArtOnly(); } catch (e) {} });
      ta.addEventListener('change', function () { K.changed(true); K.syncProps(); });
      ui.quick.appendChild(ta);
    });
  }

  // ---------- Templates ----------
  function buildTemplatesPanel() {
    var p = panel('templates', 'Templates',
      '<p class="abl-help">Pick a design and make it yours. Every word, color and shape can be changed, moved or deleted, and the layout fits whatever sign size you choose.</p>' +
      '<details class="adk-info" data-adk-info-box><summary>Fill in your details <small>(optional)</small></summary>' +
        '<label class="adk-field"><span>Business or event name</span><input class="abl-input" data-adk-info="business" maxlength="60" autocomplete="organization"></label>' +
        '<label class="adk-field"><span>Tagline or services</span><input class="abl-input" data-adk-info="tagline" maxlength="80"></label>' +
        '<label class="adk-field"><span>Phone</span><input class="abl-input" data-adk-info="phone" maxlength="30" inputmode="tel" autocomplete="tel"></label>' +
        '<label class="adk-field"><span>Website</span><input class="abl-input" data-adk-info="web" maxlength="80" inputmode="url" autocomplete="url"></label>' +
        '<p class="abl-help adk-small">Your details show on every template below. Templates with a QR spot turn your website into a QR code.</p>' +
        '<button type="button" class="adk-btn" data-adk-info-apply hidden>Update my sign with these details</button>' +
      '</details>' +
      '<div class="adk-chips" data-adk-tpl-cats></div>' +
      '<div class="adk-confirm" data-adk-confirm hidden><p>This replaces what is on this side of your sign (you can undo).</p><div><button type="button" class="adk-btn" data-adk-yes>Use this template</button><button type="button" class="adk-btn adk-btn--ghost" data-adk-no>Cancel</button></div></div>' +
      '<div class="adk-grid adk-grid--tpl" data-adk-tpl><p class="abl-help">Loading templates...</p></div>');
    ui.tplPanel = p; ui.tpl = $('[data-adk-tpl]', p); ui.tplCats = $('[data-adk-tpl-cats]', p); ui.confirm = $('[data-adk-confirm]', p);
    $$('[data-adk-info]', p).forEach(function (inp) {
      inp.addEventListener('input', function () {
        st.info[inp.getAttribute('data-adk-info')] = inp.value.replace(/^\s+/, '');
        lsSet(INFO_KEY, st.info);
        clearTimeout(st.infoT); st.infoT = setTimeout(function () { st.thumbs = {}; renderTemplates(); }, 500);
        var ab = $('[data-adk-info-apply]', p); if (ab) ab.hidden = !(faceTplItem(curFace()) || (st.tpl && st.tplFace === curFace()));
      });
    });
    $('[data-adk-info-apply]', p).addEventListener('click', function () { var t = faceTplItem(curFace()) || st.tpl; if (t) applyTemplate(t, { keepEdits: true, reason: 'info' }); });
    $('[data-adk-no]', p).addEventListener('click', function () { ui.confirm.hidden = true; st.pending = null; });
    $('[data-adk-yes]', p).addEventListener('click', function () { ui.confirm.hidden = true; if (st.pending) applyTemplate(st.pending, {}); st.pending = null; });
  }
  function syncInfoFields() { if (!ui.tplPanel) return; $$('[data-adk-info]', ui.tplPanel).forEach(function (inp) { inp.value = st.info[inp.getAttribute('data-adk-info')] || ''; }); }
  function openTemplates() { renderTemplates(); }
  function renderTemplates() {
    if (!ui.tpl) return;
    Promise.all([K.ready(), loadTpl(), load('bg'), load('qr')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var T = window.ArdorTPL, cats = T.categories ? T.categories() : (window.ArdorTPLData.categories || []);
      if (!ui.tplCats.children.length) {
        var all = el('button', 'adk-chip', 'All'); all.type = 'button'; all.setAttribute('data-c', ''); ui.tplCats.appendChild(all);
        cats.forEach(function (c) { var b = el('button', 'adk-chip', esc(c.name || c.id)); b.type = 'button'; b.setAttribute('data-c', c.id || c.name); ui.tplCats.appendChild(b); });
        ui.tplCats.addEventListener('click', function (e) { var b = e.target.closest('[data-c]'); if (!b) return; st.tplCat = b.getAttribute('data-c'); renderTemplates(); });
      }
      $$('[data-c]', ui.tplCats).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === st.tplCat ? 'true' : 'false'); });
      return fontsReady(FONT_PRE.concat(['Arial'])).then(function () {
        var z = cfgSize(), key = areaKey(z.Wi, z.Hi, tplArea(z)) + '|' + JSON.stringify(st.info);
        if (st.thumbKey !== key) { st.thumbs = {}; st.thumbKey = key; }
        var items = T.list(st.tplCat);
        ui.tpl.textContent = '';
        ui.tpl.classList.toggle('is-tall', z.Wi / z.Hi < 0.9);
        ui.tpl.classList.toggle('is-xwide', z.Wi / z.Hi >= 3.2);
        items.forEach(function (it, i) {
          var b = el('button', 'adk-card adk-card--tpl'); b.type = 'button'; b.setAttribute('aria-label', 'Use template: ' + it.name);
          b.innerHTML = '<span class="adk-card__img"></span><span class="adk-card__name">' + esc(it.name) + '</span>';
          b.addEventListener('click', function () { chooseTemplate(it); });
          ui.tpl.appendChild(b);
          lazyThumb(b, function () { $('.adk-card__img', b).appendChild(tplThumb(it, z)); }, i);
        });
      });
    }).catch(failed);
  }
  function qrPathFn(text) {
    try { var q = window.ArdorQR.encode(text, 'M'); var p = window.ArdorQR.path(q, { quiet: 0, style: 'square', finder: 'square' }); return { d: p.d, size: p.size }; } catch (e) { return null; }
  }
  // Oct 18 2026 (Claude): draw template thumbnails only when their card scrolls into view (inside the drawer list),
  // one per idle moment, instead of all of them back to back. On phones drawing every thumbnail at once froze scrolling.
  function lazyThumb(card, draw, i) {
    var run = function () { if (card.__adkThumb) return; card.__adkThumb = true; try { draw(); } catch (e) { try { console.warn(e); } catch (x) {} } };
    var idle = window.requestIdleCallback ? function (f) { window.requestIdleCallback(f, { timeout: 400 }); } : function (f) { setTimeout(f, 16); };
    if (!('IntersectionObserver' in window)) { setTimeout(run, 30 + i * 25); return; }
    var io = new IntersectionObserver(function (ents) {
      for (var k = 0; k < ents.length; k++) { if (ents[k].isIntersecting) { io.disconnect(); idle(run); return; } }
    }, { root: card.closest('.abl-drawer__body, .adk-body') || null, rootMargin: '400px 0px' });
    io.observe(card);
  }
  function tplThumb(it, z) {
    var key = 't|' + it.id;
    if (!st.thumbs[key]) {
      var maxW = 260, maxH = 170, px = Math.min(maxW / z.Wi, maxH / z.Hi);
      var cv = el('canvas'); var sc = new fabric.StaticCanvas(cv, { width: Math.round(z.Wi * px), height: Math.round(z.Hi * px), enableRetinaScaling: false, renderOnAddRemove: false });
      sc.setViewportTransform([px, 0, 0, px, 0, 0]);
      sc.add(new fabric.ArdorBg({ left: 0, top: 0, width: z.Wi, height: z.Hi, ablBg: it.bg }));
      tplBuild(it, z).forEach(function (o) { sc.add(o); });
      sc.renderAll();
      st.thumbs[key] = sc.toDataURL({ format: 'jpeg', quality: 0.85 });
      sc.dispose();
    }
    var im = new Image(); im.src = st.thumbs[key]; im.alt = ''; return im;
  }
  function designOnFace() { return objs().length > 0 || !!faceArt(); }
  function chooseTemplate(it) {
    if (designOnFace() && !(st.tpl && st.tplFace === curFace() && !st.tplDirty && !faceArt())) {
      st.pending = it; ui.confirm.hidden = false; ui.confirm.scrollIntoView({ block: 'nearest' });
      return;
    }
    applyTemplate(it, { carry: true });
  }
  // build the template for the current size; keepEdits: keep wording and colors the customer changed (by role and order)
  function applyTemplate(it, opt) {
    opt = opt || {};
    return Promise.all([K.ready(), loadTpl(), load('bg'), load('qr')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      return fontsReady(window.ArdorTPL.fonts(it));
    }).then(function () {
      var face = K.targetFace();
      var z = cfgSize();
      var old = fc.getObjects().slice();
      // Oct 20 2026: what the customer added (their logo, text, clipart, QR code) stays when the template is re-arranged
      // for a new size, refilled with their details, or swapped for another template (it used to vanish)
      var carry = (opt.keepEdits || opt.carry) ? old.filter(function (o) { return o.ablKind !== 'bg' && !o.ablTpl; }) : [];
      old = old.filter(function (o) { return carry.indexOf(o) < 0; });
      var keep = opt.keepEdits ? editsByRole(old, it.id) : null;
      var list = tplBuild(it, z);
      if (keep) restoreEdits(list, keep);
      st.rebuilding = true;
      K.setQuiet(true);
      fc.discardActiveObject();
      if (old.length) fc.remove.apply(fc, old);
      var bgSpec = (keep && keep.bg) || it.bg;
      fc.add(new fabric.ArdorBg({ left: 0, top: 0, width: z.Wi, height: z.Hi, ablBg: fitSpec(bgSpec, it.id, areaKey(z.Wi, z.Hi, tplArea(z, face))) }));
      list.forEach(function (o) { K.look(o); fc.add(o); });
      carry.forEach(function (o) { fc.bringToFront(o); });
      fitMyLogo(carry);
      fitMyQr(carry);
      K.setQuiet(false);
      st.rebuilding = false;
      if (faceArt(face) && !opt.keepEdits) { try { API.setArt(face, null); } catch (e) {} }
      st.tpl = it; st.tplFace = face; st.tplVar = window.ArdorTPL.layoutKey ? window.ArdorTPL.layoutKey(it, z.Wi, z.Hi) : window.ArdorTPL.variant(z.Wi, z.Hi); st.tplDirty = !!(keep && keep.dirty);
      K.changed(true); K.sync(); K.syncProps(); fc.requestRenderAll();
      var ab = $('[data-adk-info-apply]', ui.tplPanel); if (ab) ab.hidden = false;
      if (phone()) K.closeDrawer();
      if (opt.reason === 'size') toast('We re-arranged your template for the new size.', 5000);
      else if (opt.reason !== 'info' && opt.reason !== 'link') toast('Template added. Tap any text to change the words, or drag things around.', 5000);
      track(opt.reason === 'size' ? 'template_refit' : 'template');
      qtRefreshSoon();
    }).catch(function (e) { st.rebuilding = false; try { K.setQuiet(false); } catch (x) {} failed(e); });
  }
  function roleKey(o, counts) { var r = (o.ablRole || 'x') + ':' + (o.ablKind || o.type); counts[r] = (counts[r] || 0) + 1; return r + ':' + counts[r]; }
  function editsByRole(old, id) {
    var out = { map: {}, bg: null, dirty: st.tplDirty }, counts = {};
    old.forEach(function (o) {
      if (o.ablKind === 'bg') { out.bg = o.ablBg; return; }
      if (o.ablTpl !== id) return;
      var k = roleKey(o, counts);
      out.map[k] = { text: o.ablKind === 'text' ? o.text : null, fill: o.fill, stroke: o.stroke, ablStroke: o.ablStroke, font: o.fontFamily, built: o.__adkText };
    });
    return out;
  }
  function restoreEdits(list, keep) {
    var counts = {};
    list.forEach(function (o) {
      var k = roleKey(o, counts), e = keep.map[k]; if (!e) return;
      if (o.ablKind === 'text') {
        var boxW = o.getScaledWidth();
        var changedByUser = e.text != null && e.built != null && e.text !== e.built;
        if (changedByUser) o.set('text', e.text);
        if (e.font && e.font !== o.fontFamily) o.set('fontFamily', e.font);
        o.set({ fill: e.fill });
        if (e.ablStroke != null) { o.set({ ablStroke: e.ablStroke, stroke: e.ablStroke ? e.stroke : null, strokeWidth: e.ablStroke ? o.fontSize * e.ablStroke * 0.012 : 0 }); }
        if (typeof o.initDimensions === 'function') o.initDimensions();
        var w = o.getScaledWidth(); if (w > boxW * 1.02 && boxW > 0) o.scale(o.scaleX * boxW / w);
      } else if (e.fill && typeof e.fill === 'string' && o.ablRole !== 'qr') { o.set({ fill: e.fill }); }
    });
  }
  // remember the wording each template text was built with (to tell customer edits from tokens)
  function markBuilt(list) { list.forEach(function (o) { if (o.ablKind === 'text') o.__adkText = o.text; }); }

  // banner size changed: re-arrange the template when the layout shape changes (wide, extra wide, square, tall)
  var lastSize = '';
  function watchSize() {
    if (!booted || !K || !API) return;
    var z; try { z = cfgSize(); } catch (e) { return; }
    if (!(z.Wi > 0 && z.Hi > 0)) return;
    var key = areaKey(z.Wi, z.Hi, tplArea(z)) + '|' + curFace();
    if (key !== lastSize) {
      var first = !lastSize; lastSize = key;
      if (!first) { st.thumbs = {}; if (ui.tplPanel && !ui.tplPanel.hidden) renderTemplates(); }
    }
    try { fitAll(); } catch (e) {}
  }

  // rigid: re-arrange every face that holds a template when its page or layout area changed (any size change, holes,
  // corners), on screen or not, so 2D, 3D, proof, print file and cart never carry a squeezed layout. The face on screen
  // goes through applyTemplate (keeps edited wording, colours, fonts, the customer's own layers, a spot logo moves into
  // the new spot); an off-screen face is rebuilt in its stored layers with the same rules.
  var fitting = false;
  function fitAll() {
    if (!booted || !K || !API || fitting || st.rebuilding || st.upFile || !window.ArdorTPL || !window.ArdorTPLData) return;
    if (!canvas()) return;
    try { if (!fabric) fabric = K.fabric(); } catch (e) { return; }
    if (!fabric || !fabric.ArdorBg) return;
    var z; try { z = cfgSize(); } catch (e) { return; }
    if (!(z.Wi > 0 && z.Hi > 0)) return;
    var cf = curFace(), todo = [];
    FACES.forEach(function (f) {
      var list = faceList(f), m = faceMark(list); if (!m) return;
      var a = tplArea(z, f), key = areaKey(z.Wi, z.Hi, a);
      if (m.fit === key) return;
      var it = window.ArdorTPL.get(m.id); if (!it) return;
      var last = st.fitLast && st.fitLast[f];
      if (last && last.key === key && Date.now() - last.t < 3000) return; // never loop on one face
      todo.push({ f: f, it: it, a: a, key: key, list: list });
    });
    if (!todo.length) return;
    var fl = [];
    todo.forEach(function (x) { window.ArdorTPL.fonts(x.it).forEach(function (n) { if (fl.indexOf(n) < 0) fl.push(n); }); });
    if (!fontsOk(fl)) { fontsReady(fl).then(function () { setTimeout(fitAll, 0); }).catch(function () {}); return; }
    fitting = true;
    try {
      st.fitLast = st.fitLast || {};
      var off = false;
      todo.forEach(function (x) {
        st.fitLast[x.f] = { key: x.key, t: Date.now() };
        if (x.f === cf) applyTemplate(x.it, { keepEdits: true, reason: 'size' });
        else if (rebuildOff(x.f, x.it, z, x.a, x.key, x.list)) off = true;
      });
      if (off) { try { K.changed(false); } catch (e) {} }
    } catch (e) { try { console.warn('[ardor rigid kit] re-arrange', e); } catch (x) {} }
    fitting = false;
  }
  function rebuildOff(f, it, z, a, key, store) {
    if (!store || typeof store.splice !== 'function') return false;
    var old = store.slice();
    var carry = old.filter(function (o) { return o.ablKind !== 'bg' && !o.ablTpl; });
    var keep = editsByRole(old.filter(function (o) { return carry.indexOf(o) < 0; }), it.id);
    var list = window.ArdorTPL.build(fabric, it, z.Wi, z.Hi, a, { info: tinfo(it), qrPath: qrPathFn, variant: window.ArdorTPL.variant(a.w, a.h) });
    restoreEdits(list, keep); // (ArdorTPL.build is wrapped by wrapBuild: the built wording is already remembered)
    var out = [new fabric.ArdorBg({ left: 0, top: 0, width: z.Wi, height: z.Hi, ablBg: fitSpec(keep.bg || it.bg, it.id, key) })];
    list.forEach(function (o) { K.look(o); out.push(o); });
    var lg = carry.filter(function (o) { return o.ablRole === 'mylogo'; })[0];
    if (lg) {
      var spots = out.filter(function (o) { return o.ablRole === 'logo'; }), box = spotBox(spots);
      if (box) {
        var sc = Math.min(box.w / lg.width, box.h / lg.height);
        lg.set({ originX: 'center', originY: 'center', left: box.x + box.w / 2, top: box.y + box.h / 2, scaleX: sc, scaleY: sc }); lg.setCoords();
        out = out.filter(function (o) { return spots.indexOf(o) < 0; });
      }
    }
    var qg = carry.filter(function (o) { return o.ablKind === 'qr'; })[0];
    if (qg) {
      var qs = out.filter(function (o) { return o.ablRole === 'qr' && o.ablKind !== 'qr'; }), qb = spotBox(qs);
      if (qb && qg.width > 0) {
        var qt = Math.min(qb.w, qb.h) / qg.width;
        qg.set({ left: qb.x + qb.w / 2, top: qb.y + qb.h / 2, scaleX: qt, scaleY: qt }); qg.setCoords();
        out = out.filter(function (o) { return qs.indexOf(o) < 0; });
      }
    }
    carry.forEach(function (o) { out.push(o); });
    // every layer remembers this page as its base, so the layers file's later move-and-scale leaves it where it is
    out.forEach(function (o) { o.ablBase = { W: z.Wi, H: z.Hi, l: o.left, t: o.top, sx: o.scaleX, sy: o.scaleY }; });
    if (K.setObjectsFor) K.setObjectsFor(f, out); else store.splice.apply(store, [0, store.length].concat(out));
    track('template_refit');
    return true;
  }

  // ---------- Background ----------
  // ---------- Background ----------
  function buildBgPanel() {
    var p = panel('background', 'Background',
      '<p class="abl-help" data-adk-bg-note>Pick a color, gradient, pattern, texture or scene for the whole sign.</p>' +
      '<div class="adk-chips" data-adk-bg-cats></div>' +
      '<div class="adk-bg-custom"><label class="abl-color"><input type="color" value="#ffffff" aria-label="Pick any background color" data-adk-bg-color><span>Any color</span></label><button type="button" class="adk-btn adk-btn--ghost" data-adk-bg-none>No background</button></div>' +
      '<div class="adk-grid adk-grid--bg" data-adk-bg><p class="abl-help">Loading...</p></div>');
    ui.bgPanel = p; ui.bgGrid = $('[data-adk-bg]', p); ui.bgCats = $('[data-adk-bg-cats]', p); ui.bgNote = $('[data-adk-bg-note]', p);
    $('[data-adk-bg-color]', p).addEventListener('input', function (e) { setBackground({ t: 'solid', c: e.target.value }, true); });
    $('[data-adk-bg-color]', p).addEventListener('change', function (e) { var from = st.liveFrom; st.liveFrom = null; autoContrast({ t: 'solid', c: e.target.value }, from); K.changed(true); });
    $('[data-adk-bg-none]', p).addEventListener('click', function () { removeBackground(); });
  }
  function openBackground() {
    Promise.all([K.ready(), load('bg')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var G = window.ArdorBG;
      if (!ui.bgCats.children.length) {
        G.cats.forEach(function (c) { var b = el('button', 'adk-chip', esc(c)); b.type = 'button'; b.setAttribute('data-c', c); ui.bgCats.appendChild(b); });
        ui.bgCats.addEventListener('click', function (e) { var b = e.target.closest('[data-c]'); if (!b) return; st.bgCat = b.getAttribute('data-c'); renderBg(); });
      }
      renderBg();
    }).catch(failed);
  }
  function renderBg() {
    var G = window.ArdorBG, art = faceArt();
    $$('[data-c]', ui.bgCats).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === st.bgCat ? 'true' : 'false'); });
    ui.bgNote.innerHTML = art ? '<b>Your uploaded artwork covers the sign.</b> Colors here fill any space around your artwork. To use a gradient, pattern, texture or scene, remove your artwork first (Artwork panel).' : 'Pick a color, gradient, pattern, texture or scene for the whole sign. Your text and clipart stay on top.';
    ui.bgGrid.textContent = '';
    var z = cfgSize(), ar = clamp(z.Wi / z.Hi, 0.5, 3);
    G.gallery.filter(function (g) { return g.cat === st.bgCat; }).forEach(function (g) {
      var b = el('button', 'adk-card adk-card--bg'); b.type = 'button'; b.title = g.name; b.setAttribute('aria-label', 'Background: ' + g.name);
      var dis = art && g.spec.t !== 'solid'; if (dis) b.disabled = true;
      var w = 120, h = Math.round(w / ar);
      try { var t = G.thumb(g.spec, w, h); t.className = 'adk-bg-thumb'; b.appendChild(t); } catch (e) {}
      b.appendChild(el('span', 'adk-card__name', esc(g.name)));
      b.addEventListener('click', function () { setBackground(g.spec, false); });
      ui.bgGrid.appendChild(b);
    });
  }
  function setBackground(spec, live) {
    Promise.all([K.ready(), load('bg')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var face = K.targetFace(), art = faceArt(face);
      if (art) { // behind uploaded artwork only a plain color is possible
        if (spec.t !== 'solid') { toast('Remove your uploaded artwork first to use this background.', 5000); return; }
        art.bg = spec.c; try { API.renderArtOnly(); } catch (e) {}
        var inp = document.querySelector('[data-abb-bg]'); if (inp) inp.value = spec.c;
        return;
      }
      var z = cfgSize(), b = bgObj(), prev = b ? b.ablBg : null;
      if (b) { b.ablBg = keepFit(spec, b.ablBg); b.set({ dirty: true }); fc.requestRenderAll(); if (!live) K.changed(true); else { try { API.renderArtOnly(); } catch (e) {} } }
      else {
        st.rebuilding = true; K.setQuiet(true);
        b = new fabric.ArdorBg({ left: 0, top: 0, width: z.Wi, height: z.Hi, ablBg: spec });
        fc.add(b); fc.moveTo(b, 0);
        K.setQuiet(false); st.rebuilding = false;
        K.changed(!live);
      }
      if (!live) autoContrast(spec, prev); else if (!st.liveFrom) st.liveFrom = prev || { t: 'solid', c: '#FFFFFF' };
      if (!live && st.liveFrom) { st.liveFrom = null; }
      K.sync(); fc.requestRenderAll();
      if (!live) track('background');
    }).catch(failed);
  }
  // after a background change, flip plain black or white text that would disappear (only text sitting right on the background)
  function lum(hex) { var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim()); if (!m) return 0.5; var n = parseInt(m[1], 16); return (0.299 * (n >> 16 & 255) + 0.587 * (n >> 8 & 255) + 0.114 * (n & 255)) / 255; }
  function overShape(t, list) {
    var i = list.indexOf(t), c = t.getCenterPoint();
    for (var j = i - 1; j >= 0; j--) { var o = list[j]; if (o.ablKind === 'bg') continue; var r = o.getBoundingRect(true, true); if (c.x >= r.left && c.x <= r.left + r.width && c.y >= r.top && c.y <= r.top + r.height) return true; }
    return false;
  }
  function autoContrast(spec, prevSpec) {
    var G = window.ArdorBG; if (!G) return;
    var dark = false, was = false; try { dark = G.isDark(spec); was = prevSpec ? G.isDark(prevSpec) : false; } catch (e) { return; }
    if (dark === was) return;
    var list = objs(), changedAny = false;
    list.forEach(function (o) {
      if (o.ablKind !== 'text' || typeof o.fill !== 'string' || overShape(o, list)) return;
      var L = lum(o.fill);
      if (dark && L < 0.22) { o.set('fill', '#FFFFFF'); changedAny = true; }
      if (!dark && L > 0.85) { o.set('fill', '#16161B'); changedAny = true; }
    });
    if (changedAny) fc.requestRenderAll();
  }
  function removeBackground() {
    var art = faceArt();
    if (art) { art.bg = '#FFFFFF'; try { API.renderArtOnly(); } catch (e) {} return; }
    var b = bgObj(); if (!b) return;
    fc.remove(b); K.changed(true); fc.requestRenderAll();
  }

  // ---------- QR code ----------
  var QR_TYPES = [
    ['url', 'Website', [['url', 'Website address', 'url', 'yourwebsite.com']]],
    ['tel', 'Phone call', [['tel', 'Phone number', 'tel', '(555) 555-5555']]],
    ['sms', 'Text message', [['sms', 'Phone number', 'tel', '(555) 555-5555'], ['body', 'Message (optional)', 'text', '']]],
    ['email', 'Email', [['to', 'Email address', 'email', 'you@yourbusiness.com'], ['subject', 'Subject (optional)', 'text', '']]],
    ['wifi', 'Wi-Fi', [['ssid', 'Network name', 'text', ''], ['pass', 'Password', 'text', ''], ['enc', 'Security', 'select:WPA=WPA / WPA2,WEP=WEP,nopass=No password', 'WPA']]],
    ['vcard', 'Contact card', [['name', 'Name', 'text', ''], ['org', 'Business', 'text', ''], ['phone', 'Phone', 'tel', ''], ['email', 'Email', 'email', ''], ['url', 'Website', 'url', '']]],
    ['text', 'Plain text', [['text', 'Text', 'textarea', '']]]
  ];
  function buildQrPanel() {
    var opts = QR_TYPES.map(function (t) { return '<option value="' + t[0] + '">' + t[1] + '</option>'; }).join('');
    var p = panel('qr', 'QR code',
      '<p class="abl-help">Make a QR code people can scan from your sign. It prints sharp at any size.</p>' +
      '<label class="adk-field"><span>What should it open?</span><select class="abl-input" data-adk-qr-type>' + opts + '</select></label>' +
      '<div data-adk-qr-fields></div>' +
      '<div class="adk-two"><label class="adk-field"><span>Style</span><select class="abl-input" data-adk-qr-style><option value="square">Square</option><option value="rounded">Rounded</option></select></label>' +
      '<label class="adk-field"><span>Corners</span><select class="abl-input" data-adk-qr-finder><option value="square">Square</option><option value="rounded">Rounded</option></select></label></div>' +
      '<div class="adk-two"><label class="adk-field"><span>Code color</span><span class="abl-color"><input type="color" value="#000000" data-adk-qr-fg aria-label="QR code color"></span></label>' +
      '<label class="adk-field"><span>Behind the code</span><span class="abl-color"><input type="color" value="#ffffff" data-adk-qr-bg aria-label="QR code background color"></span></label></div>' +
      '<p class="adk-warn" data-adk-qr-warn hidden></p>' +
      '<div class="adk-qr-preview" data-adk-qr-preview></div>' +
      '<button type="button" class="adk-btn adk-btn--wide" data-adk-qr-add>Add QR code to my sign</button>' +
      '<p class="abl-help adk-small" data-adk-qr-size></p>' +
      '<p class="abl-help adk-small">Tip: test it with your phone camera on the proof before you order. Make the code about 1 in wide for every 10 in of scanning distance (about 12 in wide for people 10 ft away).</p>');
    ui.qrPanel = p; ui.qrType = $('[data-adk-qr-type]', p); ui.qrFields = $('[data-adk-qr-fields]', p);
    ui.qrPrev = $('[data-adk-qr-preview]', p); ui.qrWarn = $('[data-adk-qr-warn]', p); ui.qrAdd = $('[data-adk-qr-add]', p); ui.qrSize = $('[data-adk-qr-size]', p);
    ui.qrType.addEventListener('change', function () { qrFields(); qrPreview(); });
    ['[data-adk-qr-style]', '[data-adk-qr-finder]', '[data-adk-qr-fg]', '[data-adk-qr-bg]'].forEach(function (s) { $(s, p).addEventListener('input', qrPreview); });
    ui.qrAdd.addEventListener('click', addQr);
    qrFields();
  }
  function qrFields(vals) {
    var t = QR_TYPES.filter(function (x) { return x[0] === ui.qrType.value; })[0];
    vals = vals || {};
    ui.qrFields.textContent = '';
    t[2].forEach(function (f) {
      var lab = el('label', 'adk-field', '<span>' + esc(f[1]) + '</span>'), inp;
      if (f[2] === 'textarea') { inp = el('textarea', 'abl-input abl-textarea'); inp.rows = 3; }
      else if (f[2].indexOf('select:') === 0) {
        inp = el('select', 'abl-input');
        f[2].slice(7).split(',').forEach(function (o) { var kv = o.split('='), op = el('option'); op.value = kv[0]; op.textContent = kv[1]; inp.appendChild(op); });
      } else { inp = el('input', 'abl-input'); inp.type = f[2] === 'url' ? 'text' : f[2]; if (f[2] === 'url') inp.setAttribute('inputmode', 'url'); }
      inp.setAttribute('data-adk-qf', f[0]);
      if (f[3] && inp.tagName !== 'SELECT') inp.placeholder = f[3];
      var v = vals[f[0]] != null ? vals[f[0]] : (f[0] === 'url' && ui.qrType.value === 'url' ? st.info.web : (f[0] === 'tel' ? st.info.phone : ''));
      if (inp.tagName === 'SELECT') inp.value = vals[f[0]] || f[3]; else inp.value = v || '';
      inp.addEventListener('input', qrPreview);
      lab.appendChild(inp); ui.qrFields.appendChild(lab);
    });
  }
  function qrValues() { var v = {}; $$('[data-adk-qf]', ui.qrFields).forEach(function (i) { v[i.getAttribute('data-adk-qf')] = i.value.replace(/^\s+|\s+$/g, ''); }); return v; }
  function qrPayload(type, v) {
    var P = window.ArdorQR.payload;
    if (type === 'url') return v.url ? P.url(v.url) : '';
    if (type === 'tel') return v.tel ? P.tel(v.tel.replace(/[^\d+]/g, '')) : '';
    if (type === 'sms') return v.sms ? P.sms(v.sms.replace(/[^\d+]/g, ''), v.body || '') : '';
    if (type === 'email') return v.to ? P.email(v.to, v.subject || '', '') : '';
    if (type === 'wifi') return v.ssid ? P.wifi(v.ssid, v.pass || '', v.enc || 'WPA', false) : '';
    if (type === 'vcard') return (v.name || v.org) ? P.vcard({ name: v.name, org: v.org, phone: v.phone, email: v.email, url: v.url }) : '';
    return v.text ? P.text(v.text) : '';
  }
  function qrSettings() {
    var p = ui.qrPanel;
    return { type: ui.qrType.value, v: qrValues(), style: $('[data-adk-qr-style]', p).value, finder: $('[data-adk-qr-finder]', p).value, fg: $('[data-adk-qr-fg]', p).value, bg: $('[data-adk-qr-bg]', p).value };
  }
  function openQr() {
    load('qr').then(function () {
      var a = fc && fc.getActiveObject();
      if (a && a.ablKind === 'qr' && a.ablQr) { loadQrSettings(a); }
      else { st.qrEdit = null; ui.qrAdd.textContent = 'Add QR code to my sign'; }
      qrPreview();
    }).catch(failed);
  }
  function loadQrSettings(o) {
    var s = null; try { s = typeof o.ablQr === 'string' ? JSON.parse(o.ablQr) : o.ablQr; } catch (e) {}
    if (!s || !s.type) return;
    st.qrEdit = o;
    ui.qrType.value = s.type; qrFields(s.v || {});
    $('[data-adk-qr-style]', ui.qrPanel).value = s.style || 'square';
    $('[data-adk-qr-finder]', ui.qrPanel).value = s.finder || 'square';
    $('[data-adk-qr-fg]', ui.qrPanel).value = s.fg || '#000000';
    $('[data-adk-qr-bg]', ui.qrPanel).value = s.bg || '#ffffff';
    ui.qrAdd.textContent = 'Update this QR code';
  }
  function qrPreview() {
    if (!window.ArdorQR || !ui.qrPrev) return;
    var s = qrSettings(), data = qrPayload(s.type, s.v), Q = window.ArdorQR;
    ui.qrWarn.hidden = true;
    if (!data) { ui.qrPrev.innerHTML = '<p class="abl-help">Fill in the details above to see your code.</p>'; ui.qrAdd.disabled = true; return; }
    try {
      var q = Q.encode(data, 'M');
      ui.qrPrev.innerHTML = Q.svg(q, { fg: s.fg, bg: s.bg, px: 180, quiet: 4, style: s.style, finder: s.finder });
      ui.qrAdd.disabled = false;
      if (!Q.ok(s.fg, s.bg)) { ui.qrWarn.textContent = 'Phones scan best with a dark code on a light background. These colors may not scan.'; ui.qrWarn.hidden = false; }
    } catch (e) { ui.qrPrev.innerHTML = '<p class="adk-warn">That is too long for a QR code. Please shorten it.</p>'; ui.qrAdd.disabled = true; }
    qrSizeNote();
  }
  function qrSizeNote() {
    var o = st.qrEdit || (fc && fc.getActiveObject());
    if (!ui.qrSize || !window.ArdorQR) return;
    if (o && o.ablKind === 'qr') { var w = o.getScaledWidth(); ui.qrSize.textContent = 'On your sign this code is ' + (Math.round(w * 10) / 10) + ' in wide: easy to scan from about ' + Math.round(window.ArdorQR.scanDistanceFt(w)) + ' ft away.'; }
    else ui.qrSize.textContent = '';
  }
  function makeQrGroup(s, data, sizeIn) {
    var Q = window.ArdorQR, q = Q.encode(data, 'M');
    var p = Q.path(q, { quiet: 0, style: s.style, finder: s.finder });
    var code = new fabric.Path(p.d, { fill: s.fg, fillRule: 'evenodd', stroke: null, strokeWidth: 0, originX: 'center', originY: 'center' });
    var u = (sizeIn * 0.84) / Math.max(code.width || 1, code.height || 1);
    code.set({ scaleX: u, scaleY: u, left: 0, top: 0 });
    var r = sizeIn * 0.06;
    var plate = new fabric.Rect({ width: sizeIn, height: sizeIn, rx: r, ry: r, fill: s.bg, originX: 'center', originY: 'center', left: 0, top: 0, strokeWidth: 0 });
    var g = new fabric.Group([plate, code], { originX: 'center', originY: 'center', ablKind: 'qr', ablLabel: 'QR code', ablRole: 'qr', ablQr: JSON.stringify(s), lockScalingFlip: true });
    return g;
  }
  function addQr() {
    Promise.all([K.ready(), load('qr')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var s = qrSettings(), data = qrPayload(s.type, s.v);
      if (!data) return;
      K.targetFace();
      var z = cfgSize(), sz = Math.min(z.safe.h * 0.46, z.safe.w * 0.26, 30);
      var old = st.qrEdit && fc.getObjects().indexOf(st.qrEdit) >= 0 ? st.qrEdit : null;
      if (old) sz = old.getScaledWidth();
      // rigid: a template's QR spot gets the code in its place and at its size
      var spot = null;
      if (!old) { var phs = fc.getObjects().filter(function (o) { return o.ablRole === 'qr' && o.ablKind !== 'qr'; }); spot = phs.length ? spotBox(phs) : null; if (spot) sz = Math.max(0.5, Math.min(spot.w, spot.h)); }
      var g = makeQrGroup(s, data, sz);
      K.look(g);
      if (old) {
        g.set({ left: old.left, top: old.top, angle: old.angle || 0 });
        var idx = fc.getObjects().indexOf(old);
        K.setQuiet(true); fc.remove(old); fc.insertAt(g, idx); K.setQuiet(false);
        fc.setActiveObject(g); g.setCoords(); K.changed(true); K.syncProps();
      } else {
        g.set({ left: z.safe.x + z.safe.w - sz / 2 - z.safe.w * 0.04, top: z.safe.y + z.safe.h / 2 });
        if (z.safe.w / z.safe.h < 1) g.set({ left: z.Wi / 2, top: z.safe.y + z.safe.h - sz / 2 - z.safe.h * 0.04 });
        if (spot) g.set({ left: spot.x + spot.w / 2, top: spot.y + spot.h / 2 });
        K.place(g);
      }
      st.qrEdit = g; ui.qrAdd.textContent = 'Update this QR code';
      qrSizeNote();
      // a template's QR spot placeholder is no longer needed
      var ph = fc.getObjects().filter(function (o) { return o.ablRole === 'qr' && o.ablKind !== 'qr'; });
      if (ph.length && !old) { K.setQuiet(true); fc.remove.apply(fc, ph); K.setQuiet(false); K.changed(true); }
      track('qr_' + s.type);
    }).catch(failed);
  }

  // ---------- properties panel extras (QR code, logo spot) ----------
  function buildPropsExtras() {
    var props = K.ui().props; if (!props) return;
    var qrBox = el('div', 'adk-props-qr', '<p class="abl-help" data-adk-pqr-size></p><button type="button" class="abl-done" data-adk-pqr-edit>Edit QR code</button>');
    qrBox.setAttribute('data-abl-p', 'qr'); qrBox.hidden = true;
    var logoBox = el('div', 'adk-props-logo', '<p class="abl-help">This is a spot for your logo.</p><label class="adk-btn adk-btn--wide adk-file">Add my logo<input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" data-adk-logo-file hidden></label>');
    logoBox.hidden = true;
    var head = $('.abl-props__head', props);
    if (head && head.nextSibling) props.insertBefore(logoBox, head.nextSibling); else props.appendChild(logoBox);
    props.appendChild(qrBox);
    ui.pQr = qrBox; ui.pLogo = logoBox;
    $('[data-adk-pqr-edit]', qrBox).addEventListener('click', function () { if (ui.tQr) ui.tQr.click(); });
    var tt = K.ui().pTitle;
    if (tt && window.MutationObserver) new MutationObserver(function () {
      var o = fc && fc.getActiveObject(); if (!o) return;
      var want = o.ablKind === 'qr' ? 'QR code' : (o.ablRole === 'logo' ? 'Logo spot' : '');
      if (want && tt.textContent !== want) tt.textContent = want;
    }).observe(tt, { childList: true, characterData: true, subtree: true });
    $('[data-adk-logo-file]', logoBox).addEventListener('change', function (e) { var f = e.target.files && e.target.files[0]; e.target.value = ''; if (f) addLogo(f); });
  }
  function selSync() {
    var o = fc && fc.getActiveObject(), u = K.ui();
    if (ui.pLogo) ui.pLogo.hidden = !(o && o.ablRole === 'logo');
    if (o && o.ablKind === 'qr' && u && u.pTitle) {
      u.pTitle.textContent = 'QR code';
      var w = o.getScaledWidth(), sz = $('[data-adk-pqr-size]', ui.pQr);
      if (sz && window.ArdorQR) sz.textContent = Math.round(w * 10) / 10 + ' in wide. Easy to scan from about ' + Math.round(window.ArdorQR.scanDistanceFt(w)) + ' ft.';
      if (ui.qrPanel && !ui.qrPanel.hidden) { loadQrSettings(o); qrPreview(); }
    }
    if (o && o.ablRole === 'logo' && u && u.pTitle) u.pTitle.textContent = 'Logo spot';
  }
  // logo spots' combined box in banner inches, or null
  function spotBox(spots) {
    var b = null;
    spots.forEach(function (o) {
      var r = o.getBoundingRect(true, true);
      if (!b) b = { l: r.left, t: r.top, r: r.left + r.width, b: r.top + r.height };
      else { b.l = Math.min(b.l, r.left); b.t = Math.min(b.t, r.top); b.r = Math.max(b.r, r.left + r.width); b.b = Math.max(b.b, r.top + r.height); }
    });
    return b ? { x: b.l, y: b.t, w: b.r - b.l, h: b.b - b.t } : null;
  }
  // after a re-layout: the customer's logo that filled a logo spot moves into the new layout's logo spot
  function fitMyLogo(list) {
    var lg = list.filter(function (o) { return o.ablRole === 'mylogo'; })[0];
    if (!lg) return;
    var spots = fc.getObjects().filter(function (o) { return o.ablRole === 'logo'; }), box = spotBox(spots);
    if (!box) return;
    var s = Math.min(box.w / lg.width, box.h / lg.height);
    lg.set({ originX: 'center', originY: 'center', left: box.x + box.w / 2, top: box.y + box.h / 2, scaleX: s, scaleY: s });
    lg.setCoords();
    fc.remove.apply(fc, spots);
  }
  // rigid (Oct 20 2026): after a re-layout, the customer's own QR code moves into the new layout's QR spot (the spot's
  // placeholder or website code goes), so a re-arranged or refilled template never shows two codes
  function fitMyQr(list) {
    var g = list.filter(function (o) { return o.ablKind === 'qr'; })[0];
    if (!g || !(g.width > 0)) return;
    var spots = fc.getObjects().filter(function (o) { return o.ablRole === 'qr' && o.ablKind !== 'qr'; }), box = spotBox(spots);
    if (!box) return;
    var s = Math.min(box.w, box.h) / g.width;
    g.set({ left: box.x + box.w / 2, top: box.y + box.h / 2, scaleX: s, scaleY: s });
    g.setCoords();
    fc.remove.apply(fc, spots);
  }
  var IMG_RX = /^image\/(png|jpeg|webp|svg\+xml|gif)$/;
  function isImg(f) { return IMG_RX.test(f.type || '') || /\.(png|jpe?g|webp|svg|gif)$/i.test(f.name || ''); }
  function isSvg(f) { return /svg/i.test(f.type || '') || /\.svg$/i.test(f.name || ''); }
  // the designer's own file preview (PDF, AI, EPS, TIFF, PSD), loaded the same way the designer loads it
  var avP = null;
  function artView() {
    var cf = (API && API.conf) || {};
    if (!window.ArdorBannerArtView && !avP) {
      if (!cf.artviewUrl) return Promise.reject(new Error('no file preview'));
      avP = new Promise(function (res, rej) {
        var sc = document.createElement('script'); sc.src = cf.artviewUrl; sc.async = true;
        sc.onload = function () { if (window.ArdorBannerArtView) res(window.ArdorBannerArtView); else { avP = null; rej(new Error('file preview')); } };
        sc.onerror = function () { avP = null; rej(new Error('file preview')); };
        document.head.appendChild(sc);
      });
    }
    return (window.ArdorBannerArtView ? Promise.resolve(window.ArdorBannerArtView) : avP).then(function (av) {
      try { av.config({ lib: cf.pdfjsUrl, worker: cf.pdfjsWorkerUrl }); } catch (e) {}
      return av;
    });
  }
  // any upload as a canvas: images drawn up to 2400 px (SVG drawn at 2400 px so it prints sharp), other files previewed
  function fileCanvas(file) {
    if (!isImg(file)) {
      return artView().then(function (av) { return av.preview(file, { maxPx: 2400 }); }).then(function (r) {
        if (!r || !r.ok || !r.canvas) throw new Error('no preview');
        return { cv: r.canvas, png: true };
      });
    }
    return new Promise(function (res, rej) {
      var rd = new FileReader();
      rd.onload = function () {
        var img = new Image();
        img.onload = function () {
          var max = 2400, w = img.naturalWidth || 800, h = img.naturalHeight || 800;
          var k = isSvg(file) ? max / Math.max(w, h) : Math.min(1, max / Math.max(w, h));
          var cv = el('canvas'); cv.width = Math.max(1, Math.round(w * k)); cv.height = Math.max(1, Math.round(h * k));
          cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
          res({ cv: cv, png: !/jpe?g/i.test(file.type || '') });
        };
        img.onerror = function () { rej(new Error('image')); };
        img.src = rd.result;
      };
      rd.onerror = function () { rej(new Error('read')); };
      rd.readAsDataURL(file);
    });
  }
  // a logo or image as its own layer on top of the template and background. The logo spot's own button (opt.spot not
  // false) fills the template's logo spots; otherwise the image is fitted inside the safe area, centered and selected.
  // RS-CORE round 5: a place for a logo when no logo spot is left: the biggest free box in the safe area, as near the
  // middle as it can be, over no text, logo, picture or QR code (first also over no shape); else a quarter-size box in
  // the next corner, so logos never land on top of each other
  function freeBox(sf, ar) {
    ar = ar > 0 ? ar : 1;
    var all = objs().filter(function (o) { return o.visible !== false && o.ablKind !== 'bg'; }).map(function (o) {
      var r = o.getBoundingRect(true, true); return { x: r.left, y: r.top, w: r.width, h: r.height, k: o.ablKind || '', role: o.ablRole || '' };
    });
    var hard = function (r) { return /^(text|qr|image|clipart)$/.test(r.k) || /logo/.test(r.role); };
    var soft = function (r) { return hard(r) || r.w * r.h < sf.w * sf.h * 0.6; };
    var passes = [all.filter(soft), all.filter(hard)], gap = Math.min(sf.w, sf.h) * 0.03;
    var cx = sf.x + sf.w / 2, cy = sf.y + sf.h / 2;
    var dist = function (b) { var dx = b.x + b.w / 2 - cx, dy = b.y + b.h / 2 - cy; return dx * dx + dy * dy; };
    for (var p = 0; p < passes.length; p++) {
      for (var f = 0.5; f > 0.149; f -= 0.05) {
        var bw = sf.w * f, bh = bw / ar; if (bh > sf.h * f) { bh = sf.h * f; bw = bh * ar; }
        var cand = [];
        for (var i = 0; i <= 8; i++) for (var j = 0; j <= 8; j++) cand.push({ x: sf.x + (sf.w - bw) * i / 8, y: sf.y + (sf.h - bh) * j / 8, w: bw, h: bh });
        cand.sort(function (a, b) { return dist(a) - dist(b); });
        for (var c = 0; c < cand.length; c++) {
          var bx = cand[c];
          if (!passes[p].some(function (r) { return bx.x < r.x + r.w + gap && bx.x + bx.w > r.x - gap && bx.y < r.y + r.h + gap && bx.y + bx.h > r.y - gap; })) return bx;
        }
      }
    }
    var n = all.filter(function (r) { return r.k === 'image'; }).length % 4, qw = sf.w * 0.25, qh = qw / ar;
    if (qh > sf.h * 0.25) { qh = sf.h * 0.25; qw = qh * ar; }
    return { x: n % 2 ? sf.x + sf.w - qw : sf.x, y: n > 1 ? sf.y + sf.h - qh : sf.y, w: qw, h: qh };
  }
  function addLogo(file, opt) {
    opt = opt || {};
    if (!file) return Promise.resolve(null);
    if (file.size > 25 * 1024 * 1024) { toast('That file is over 25 MB. Please pick a smaller file.', 5000); return Promise.resolve(null); }
    return Promise.all([K.ready(), fileCanvas(file)]).then(function (r) {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      K.targetFace();
      var url = r[1].cv.toDataURL(r[1].png ? 'image/png' : 'image/jpeg', 0.92);
      return new Promise(function (res) {
        fabric.Image.fromURL(url, function (im) {
          if (!im || !im.width) { res(null); return; }
          var spots = opt.spot === false ? [] : fc.getObjects().filter(function (o) { return o.ablRole === 'logo'; });
          var box = spotBox(spots), z = cfgSize();
          if (!box) box = freeBox(z.safe, im.width / im.height);
          var s = Math.min(box.w / im.width, box.h / im.height);
          im.set({ originX: 'center', originY: 'center', left: box.x + box.w / 2, top: box.y + box.h / 2, scaleX: s, scaleY: s, ablKind: 'image', ablLabel: 'Your logo' });
          if (spots.length) im.set('ablRole', 'mylogo');
          K.look(im);
          K.setQuiet(true); if (spots.length) fc.remove.apply(fc, spots); K.setQuiet(false);
          K.place(im);
          track('logo');
          res(im);
        });
      });
    }).then(function (im) {
      if (!im) toast('We could not read that file. Please try a PNG, JPG or SVG.', 6000);
      return im;
    }, function () { toast('We could not read that file. Please try a PNG, JPG or SVG.', 6000); return null; });
  }

  // ---------- uploads over a template or background (Oct 20 2026) ----------
  // The designer draws uploaded artwork UNDER the layers. A template (or a full background) puts a background layer at
  // the bottom of the layers, so artwork uploaded after it was hidden everywhere (screen, 3D, proof and print file).
  // Now an upload on a side with a background layer asks first: add it as a logo on the template (its own layer on top,
  // fitted inside the safe area) or use it as the full artwork (the template's own layers and the background are removed;
  // anything the customer added stays on top). A design sent by the AI tools replaces the template directly.
  function sideObjs(face) { try { return K.objectsFor(face) || []; } catch (e) { return []; } }
  function hidesArt(face) { return sideObjs(face).some(function (o) { return o.ablKind === 'bg'; }); }
  function tplOn(face) { return sideObjs(face).some(function (o) { return !!o.ablTpl; }); }
  function upFace() { var s = API && API.state; return s && s.face === 'back' ? 'back' : 'front'; }
  // remove the template's own layers and the background from the side being edited. The customer's own layers stay,
  // and so does a real QR code the template made from their website (it is no longer part of a template).
  // why: 'ask' (the customer picked full artwork), 'ai' (a design from the AI tools), 'show' (Show my artwork)
  function clearTemplate(why) {
    if (!canvas()) return false;
    var face = K.targetFace(), what = tplOn(face) ? 'template' : 'background', kept = 0;
    var rm = fc.getObjects().filter(function (o) {
      if (o.ablKind === 'bg') return true;
      if (!o.ablTpl) { kept++; return false; }
      if (o.ablKind === 'qr' && o.ablQr) { o.ablTpl = null; kept++; return false; }
      return true;
    });
    if (!rm.length) return false;
    K.setQuiet(true); fc.discardActiveObject(); fc.remove.apply(fc, rm); K.setQuiet(false);
    if (st.tplFace === face) { st.tpl = null; st.tplDirty = false; }
    var ab = ui.tplPanel && $('[data-adk-info-apply]', ui.tplPanel); if (ab) ab.hidden = true;
    delete park[face]; lastSig[face] = null;
    K.changed(true); K.sync(); K.syncProps(); fc.requestRenderAll(); qtRefreshSoon();
    if (why === 'ai') toast('Your new design replaced the ' + what + ' on your sign.', 6000);
    else if (why === 'ask') toast('We took the ' + what + ' off your sign. Your artwork fills it now.' + (kept ? ' What you added yourself stays on top.' : '') + ' Undo brings the ' + what + ' back.', 7000);
    return true;
  }
  function upUi() {
    if (ui.up) return ui.up;
    if (!document.getElementById('adk-up-css')) {
      var cs = el('style'); cs.id = 'adk-up-css';
      cs.textContent = '.adk-up{border:0;border-radius:14px;padding:22px 20px 16px;width:calc(100vw - 32px);max-width:420px;box-sizing:border-box;' +
        'box-shadow:0 18px 48px rgba(0,0,0,.28);font:inherit;color:#16161b;background:#fff}.adk-up::backdrop{background:rgba(12,13,13,.45)}' +
        '.adk-up h3{margin:0 0 6px;font-size:18px;line-height:1.25}.adk-up p{margin:0 0 16px;font-size:14px;line-height:1.45;color:#3d3a36;overflow-wrap:anywhere}' +
        '.adk-up__acts{display:flex;flex-direction:column;gap:10px}.adk-up__acts .adk-btn{width:100%;min-height:44px;justify-content:center;text-align:center;white-space:normal;line-height:1.3}' +
        '.adk-up__x{align-self:center;background:none;border:0;padding:8px 12px;font:inherit;font-size:14px;color:#3d3a36;text-decoration:underline;cursor:pointer}';
      document.head.appendChild(cs);
    }
    var d = el('dialog', 'adk-up', '<h3 id="adk-up-title" data-adk-up-title></h3><p data-adk-up-text></p><div class="adk-up__acts">' +
      '<button type="button" class="adk-btn adk-btn--wide" data-adk-up-logo></button>' +
      '<button type="button" class="adk-btn adk-btn--wide adk-btn--ghost" data-adk-up-full></button>' +
      '<button type="button" class="adk-up__x" data-adk-up-cancel>Cancel</button></div>');
    d.setAttribute('aria-labelledby', 'adk-up-title');
    document.body.appendChild(d);
    $('[data-adk-up-logo]', d).addEventListener('click', function () { upDone('logo'); });
    $('[data-adk-up-full]', d).addEventListener('click', function () { upDone('full'); });
    $('[data-adk-up-cancel]', d).addEventListener('click', function () { upDone(''); });
    d.addEventListener('cancel', function (e) { e.preventDefault(); upDone(''); });
    d.addEventListener('click', function (e) {
      if (e.target !== d) return;
      var r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) upDone('');
    });
    ui.up = d; return d;
  }
  function askUpload(file) {
    var d = upUi(), what = tplOn(upFace()) ? 'template' : 'background';
    $('[data-adk-up-title]', d).textContent = 'You have a ' + what + ' on your sign';
    $('[data-adk-up-text]', d).innerHTML = 'How do you want to use <b>' + esc(file.name || 'your file') + '</b>?';
    $('[data-adk-up-logo]', d).textContent = 'Add as a logo on the ' + what;
    $('[data-adk-up-full]', d).textContent = 'Use as full artwork (replaces the ' + what + ')';
    st.upFile = file;
    try { if (!d.open) d.showModal(); } catch (e) { d.setAttribute('open', ''); }
    track('upload_choice');
  }
  function upDone(how) {
    var d = ui.up, f = st.upFile; st.upFile = null;
    try { d.close(); } catch (e) { d.removeAttribute('open'); }
    if (!f) return;
    if (how === 'logo') {
      track('upload_as_logo');
      addLogo(f, {}).then(function (im) {
        if (im) toast(im.ablRole === 'mylogo' ? 'Your logo is in the template\'s logo spot. Drag or resize it any time.' : 'Your logo is on the sign. Drag or resize it any time.', 6000);
      });
      return;
    }
    if (how === 'full') { track('upload_as_artwork'); clearTemplate('ask'); passUpload(f); return; }
    toast('Nothing was added to your sign.', 4000);
  }
  // hand the file to the designer's own upload, exactly as if it had been picked with no template on the sign
  function passUpload(f) {
    var inp = $('[data-abb-file]'), ok = false;
    st.upPass = true;
    try {
      if (inp && window.DataTransfer) { try { var dt = new DataTransfer(); dt.items.add(f); inp.files = dt.files; ok = true; } catch (e) {} }
      if (ok) inp.dispatchEvent(new Event('change', { bubbles: true }));
      else if (API && API.loadFile) API.loadFile(f, upFace(), true);
    } finally { st.upPass = false; }
  }
  // safety net (same rule as the real estate kit): artwork and a background layer never share a side. When Undo brings
  // a template back over uploaded artwork, the artwork is taken off ("parked") with a message, and Redo puts it back.
  var park = {}, lastSig = {};
  function sigOf(list) { return list.map(function (o) { return [o.type, o.ablKind || '', o.ablRole || '', Math.round((o.left || 0) * 1000), Math.round((o.top || 0) * 1000)].join(':'); }).join('|'); }
  function checkHidden() {
    if (!booted || !canvas() || st.upFile || st.rebuilding) return;
    var f = curFace(), a = faceArt(f), list = sideObjs(f), bg = hidesArt(f);
    if (a && !bg) { lastSig[f] = sigOf(list); return; }
    if (a && bg) {
      var known = typeof lastSig[f] === 'string';
      park[f] = { art: a, sig: known ? lastSig[f] : null };
      try { API.setArt(f, null); API.render(); } catch (e) {}
      toast(known ? 'Undo brought the ' + (tplOn(f) ? 'template' : 'background') + ' back, so your uploaded artwork is off the sign for now. Redo puts it back.' : 'Your uploaded artwork was behind the ' + (tplOn(f) ? 'template' : 'background') + ', so we took it off the sign. Upload it again to add it.', 8000);
      track('artwork_parked');
      return;
    }
    if (!a && !bg && park[f] && park[f].sig !== null && sigOf(list) === park[f].sig) {
      var x = park[f]; delete park[f];
      try { API.setArt(f, x.art); API.render(); } catch (e) {}
      toast('Your artwork is back on the sign.', 4000);
    }
  }
  function guardUploads() {
    var inp = $('[data-abb-file]'), drop = $('[data-abb-drop]');
    setInterval(checkHidden, 700);
    var hostC = inp && inp.parentNode, hostD = drop && drop.parentNode;
    // capture on a parent, so this runs before the designer's own listener on the file input
    if (hostC && !hostC.__adkUp) {
      hostC.__adkUp = true;
      hostC.addEventListener('change', function (e) {
        if (st.upPass || e.target !== inp) return;
        var f = inp.files && inp.files[0];
        if (!f || !hidesArt(upFace())) return;
        e.stopImmediatePropagation(); e.stopPropagation();
        inp.value = '';
        askUpload(f);
      }, true);
    }
    if (hostD && !hostD.__adkUpD) {
      hostD.__adkUpD = true;
      hostD.addEventListener('drop', function (e) {
        if (!drop.contains(e.target)) return;
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (!f || !hidesArt(upFace())) return;
        e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
        drop.classList.remove('is-over');
        askUpload(f);
      }, true);
    }
    // designs placed by code (the AI design tools) replace the template on that side
    if (API && typeof API.loadFile === 'function' && !API.__adkUp) {
      var lf = API.loadFile; API.__adkUp = true;
      API.loadFile = function (file, face) {
        try { var f2 = face === 'back' ? 'back' : 'front'; if (file && !st.upPass && f2 === K.face() && hidesArt(f2)) clearTemplate('ai'); } catch (e) {}
        return lf.apply(this, arguments);
      };
    }
  }

  // wrap ArdorTPL.build so every built text remembers its original wording
  function wrapBuild() {
    var T = window.ArdorTPL; if (!T || T.__adkWrapped) return;
    var b = T.build; T.build = function () { var r = b.apply(T, arguments); markBuilt(r); return r; }; T.__adkWrapped = true;
  }
  var _lt = loadTpl; loadTpl = function () { return _lt().then(function (x) { wrapBuild(); return x; }); };

  // before Add to cart: warn once when sample words or empty logo / QR spots are still on the sign
  var SAMPLE = /YOUR BUSINESS|\(555\) 555-5555|YOURWEBSITE\.COM|YOUR TAGLINE HERE|MONTH DAY|YOUR ADDRESS, CITY|YOUR LOGO|YOUR QR CODE|TEAM NAME|GRADUATE NAME|ADD A HEADING|ADD A SUBHEADING|ADD A LITTLE BIT OF BODY TEXT|ITEM NAME|\$0\.00|EVENT NAME|YOUR NETWORK|YOUR PASSWORD|UP TO 50% OFF|@YOURHANDLE/i;
  function leftovers() {
    if (!K || !fc) return [];
    var out = [];
    ['front', 'back'].forEach(function (f) {
      (K.objectsFor(f) || []).forEach(function (o) {
        if (o.ablKind === 'text' && SAMPLE.test(String(o.text || '').replace(/\s+/g, ' '))) out.push(String(o.text).replace(/\s+/g, ' ').slice(0, 40));
        else if (o.ablRole === 'logo' && o.ablKind !== 'text' && out.indexOf('YOUR LOGO') < 0) out.push('YOUR LOGO');
      });
    });
    return out.filter(function (v, i, a) { return a.indexOf(v) === i; });
  }
  var cartOk = 0;
  document.addEventListener('click', function (e) {
    try { fitAll(); } catch (x) {} // every click: faces are fitted before 3D, proof, PDF, print or Add to cart read them
    var b = e.target.closest && e.target.closest('[data-abb-add], [data-abb-add-d], [data-abb-add-m]');
    if (!b || Date.now() - cartOk < 60000) return;
    var left = leftovers();
    if (!left.length) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    toast('Your sign still shows sample text: ' + left.slice(0, 4).join(', ') + (left.length > 4 ? '...' : '') + '. Change or delete it before you order.', 12000, { label: 'Order anyway', run: function () { cartOk = Date.now(); b.click(); } });
    track('sample_text_warning');
  }, true);

  window.ArdorRigidKit = { v: 1, fix: 'upload-oct20', kit: 'rigid', addLogo: addLogo, fitAll: function () { fitAll(); },
    designFor: function (face) { return hidesArt(face || upFace()) || tplOn(face || upFace()); },
    clearDesign: function (face, why) { return clearTemplate(why === 'ask' ? 'ask' : 'ai'); },
    askUpload: function (o) { if (o && o.file) askUpload(o.file); },
    uploadAsLogo: function (file) { return addLogo(file, {}); },
    area: function (face) { try { return tplArea(cfgSize(), face); } catch (e) { return null; } },
    applyTemplate: function (id) { return loadTpl().then(function () { return applyTemplate(window.ArdorTPL.get(id), {}); }); }, setBackground: setBackground, state: st };
  if (window.ArdorRigidLayers && window.ArdorRigidLayers.kit) boot();
  else document.addEventListener('ardor:layers-kit', boot);
  var tries = 0, t = setInterval(function () { if (booted || ++tries > 80) { clearInterval(t); return; } boot(); }, 250);
})();
